'use strict';

var _regeneratorRuntime = require("/home/hashir/WORK/secureX/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/hashir/WORK/secureX/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var dagNodeUtil = require('./util');

var cloneLinks = dagNodeUtil.cloneLinks;
var cloneData = dagNodeUtil.cloneData;
var toDAGLink = dagNodeUtil.toDAGLink;

var DAGLink = require('../dag-link');

var DAGNode = require('./index');

var create = require('./create');

var asDAGLink = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(link) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!DAGLink.isDAGLink(link)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", link);

          case 2:
            if (!DAGNode.isDAGNode(link)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", toDAGLink(link, {}));

          case 4:
            return _context.abrupt("return", new DAGLink(link.Name || link.name, link.Tsize || link.size, link.Hash || link.multihash || link.hash || link.cid));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function asDAGLink(_x) {
    return _ref.apply(this, arguments);
  };
}();

var addLink = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(node, link) {
    var links, data, dagLink;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            links = cloneLinks(node);
            data = cloneData(node);
            _context2.next = 4;
            return asDAGLink(link);

          case 4:
            dagLink = _context2.sent;
            links.push(dagLink);
            return _context2.abrupt("return", create(data, links));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function addLink(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

module.exports = addLink;